// Runtime config accessor (the zehn SPA contract — zehnmind/zehn-ci-workflows
// templates/spa). Read EVERY tier-specific value through `env()`, never
// `import.meta.env` directly.
//
// The container writes the pod's config into /env-config.js at start
// (docker/40-env-config.sh → window.__ENV__), and index.html loads it as a
// classic script before the app, so module-level reads already see it. The
// image is built with none of these values: the same bytes run on staging and
// on any other cluster. `buildEnv` is the fallback for `npm run dev`, where
// Vite supplies them; Vite only inlines LITERAL `import.meta.env.VITE_X`
// reads, hence the static map.
//
// There is no API URL: the screen calls its own origin (docs-api's routes,
// /bff and /pass through the Vite proxy in dev, nginx in the image).
const buildEnv = {
  // The install's modules, a JSON list of {code, name, url} (installModules.js):
  // the top bar's modules, and the pages that may open docs' intent pages.
  VITE_ZEHN_MODULES: import.meta.env.VITE_ZEHN_MODULES,
  // The client's own pages (its portal) that may frame this app and open its
  // intent pages, a JSON list of exact origins (installModules.js parseHosts).
  VITE_ZEHN_HOSTS: import.meta.env.VITE_ZEHN_HOSTS,
  // The domain of the person's theme and language cookie (zehn_prefs), shared
  // by the install's modules. Optional: by default the longest common parent
  // of the modules' hosts.
  VITE_ZEHN_PREFS_DOMAIN: import.meta.env.VITE_ZEHN_PREFS_DOMAIN,
  VITE_COLLABORA_URL: import.meta.env.VITE_COLLABORA_URL,
  VITE_EIMZO_API_KEYS: import.meta.env.VITE_EIMZO_API_KEYS,
  // The zehn-aip doc agent panel (…/doc-agent-panel/) the editor's dock frames.
  VITE_AIP_PANEL_URL: import.meta.env.VITE_AIP_PANEL_URL,
  VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  VITE_SENTRY_ENVIRONMENT: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  VITE_SENTRY_TRACES_SAMPLE_RATE: import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE,
};

export const env = (key) => {
  const runtimeValue = typeof window !== 'undefined' ? window.__ENV__?.[key] : undefined;
  if (typeof runtimeValue === 'string' && runtimeValue !== '') {
    return runtimeValue;
  }
  return buildEnv[key];
};

// What this deploy calls itself: the chart's appVersion (the snapshot on
// staging, X.Y.Z once this same image is promoted) and its tier. Empty in
// `npm run dev`.
export const runtimeRelease = () => (typeof window !== 'undefined' && window.__RELEASE__) || {};
